let aafliii = {
    "pinned": [
      "Id"
    ],
    "width": {
      "Deal": 240,
      "WireDate": 94
    },
    "immutable": {
      "Total": true,
      "CashBalance": true,
      "CKGBalance": true,
      "CoInvestCKGBalance": true,
      "Id": true
    },
    "mapping": {
      "Id": {
        "header": "Id",
        "rules": null,
        "dataType": "Int",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Id"
      },
      "Deal": {
        "header": "Deal",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Deal",
        "cellEditor": "agTextCellEditor"
      },
      "WireDate": {
        "header": "Wire Date",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "WireDate"
      },
      "FRBBalancedCKG": {
        "header": "FRB Balanced Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FRBBalancedCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "BalancedCKG": {
        "header": "Balanced Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "BalancedCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "CoInvestCKG": {
        "header": "Co-Invest Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CoInvestCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FRBCoInvestCKG": {
        "header": "FRB Co-Invest Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FRBCoInvestCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "Total": {
        "header": "Total",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Total",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      // "FRBLoc": {
      //   "header": "FRB LOC",
      //   "rules": null,
      //   "dataType": "text",
      //   "meta": null,
      //   "palceholder": null,
      //   "validations": null,
      //   "col": "FRBLoc",
      //   "textAlign": 'right',
      //   "cellEditor": "agTextCellEditor"
      // },
      "CashBalance": {
        "header": "Cash Balance",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CashBalance",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "CKGBalance": {
        "header": "Checking Balance",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CKGBalance",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "CoInvestCKGBalance": {
        "header": "Co-Invest Checking Balance",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CoInvestCKGBalance",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "AutomatedComments": {
        "header": "Automated Comments",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AutomatedComments",
        "cellEditor": "agTextCellEditor"
      },
      "TiesToBank": {
        "header": "Ties to Bank",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "TiesToBank",
        "cellEditor": "agTextCellEditor"
      },
      "Notes": {
        "header": "Notes",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Notes",
        "cellEditor": "agTextCellEditor"
      },
      "FXRate": {
        "header": "FXRate",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FXRate",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FXRateDate": {
        "header": "Date of FX Rate",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FXRateDate"
      } 
    }
  }
  export  { aafliii }
  